import React, { ReactElement } from "react";
import { Box, Chip, Paper, Stack, Typography } from "@mui/material";

interface WNLISamplesProps {
  sampleSelectedCallback?: (sentence1: string, sentence2: string) => void;
}

const Samples = (props: WNLISamplesProps): ReactElement => {
  const { sampleSelectedCallback } = props;

  const getLabelText = (label: string): string => {
    return label === "LABEL_1" ? "Entails" : "Does not entail";
  };

  const SAMPLES: { sentence1: string; sentence2: string; label: string }[] = [
    { sentence1: "Joao nao conseguiu levantar a mala de Pedro porque ela era muito pesada.", sentence2: "A mala era muito pesada.", label: "LABEL_1" },
    { sentence1: "Ana agradeceu a Maria porque ela ajudou no projeto.", sentence2: "Maria ajudou no projeto.", label: "LABEL_1" },
    { sentence1: "O trofeu nao cabia na mala porque ele era grande demais.", sentence2: "A mala era grande demais.", label: "LABEL_0" },
    { sentence1: "Carlos ligou para Miguel depois que ele terminou a reuniao.", sentence2: "Miguel terminou a reuniao.", label: "LABEL_1" },
    { sentence1: "A chave nao abriu a porta porque ela estava enferrujada.", sentence2: "A porta estava enferrujada.", label: "LABEL_0" },
  ];

  return (
    <>
      {SAMPLES.map((sample, index) => {
        return (
          <Paper
            key={"sample-" + index}
            variant="elevation"
            elevation={4}
            sx={{
              padding: "8px",
              marginBottom: "10px",
              border: "1px solid",
              borderColor: "primary.light",
              backgroundColor: "background.paper",
              cursor: "pointer",
              transition: "box-shadow 0.2s ease, transform 0.2s ease",
              "&:hover": {
                boxShadow: 6,
                transform: "translateY(-2px)",
              },
            }}
            onClick={() => {
              sampleSelectedCallback &&
                sampleSelectedCallback(sample.sentence1, sample.sentence2);
            }}
          >
            <Stack spacing={1.5}>
              <Chip
                label={sample.label + " · " + getLabelText(sample.label)}
                color={sample.label === "LABEL_1" ? "success" : "default"}
                variant={sample.label === "LABEL_1" ? "filled" : "outlined"}
                size="small"
                sx={{ alignSelf: "flex-start", fontWeight: 700 }}
              />
              <Box>
                <Typography
                  variant="caption"
                  sx={{ fontWeight: 700, color: "primary.main" }}
                >
                  Sentence 1
                </Typography>
                <Typography variant="body2">{sample.sentence1}</Typography>
              </Box>
              <Box>
                <Typography
                  variant="caption"
                  sx={{ fontWeight: 700, color: "primary.main" }}
                >
                  Sentence 2
                </Typography>
                <Typography variant="body2">{sample.sentence2}</Typography>
              </Box>
            </Stack>
          </Paper>
        );
      })}
    </>
  );
};

export default Samples;
